export const AuthorizationFlows = {
  ConnectIntegration: 'connect-integration',
  Git: {
    LaunchRepoAsGrader: 'git:launch-repo-as-grader',
    LaunchRepoAsLearner: 'git:launch-repo-as-learner',
  },
} as const;
